<template>
  <div id="Course">
    <div class="box" ref="box">
      <div class="left">
        <div class="resize" title="收缩侧边栏"></div>
        <a-spin :spinning="tree.treeLoading">
          <a-tabs @change="tabsChange" v-model="tabActive" :key="tabKey">
            <a-tab-pane v-for="item in tabs" :key="item.type">
              <span slot="tab">&nbsp;{{ item.name }}&nbsp;</span>
            </a-tab-pane>
          </a-tabs>
          <div>
            <a-tree @select="treeSelect" :tree-data="tree.treeData"
                    :selectedKeys.sync="tree.selectValue"
                    style="padding-right: 5px;"
                    :expandedKeys.sync="tree.expandedKeys"
                    :key="tree.key"
                    :replaceFields="{ key: 'id', title: 'name' }"
                    show-icon block-node>
              <template slot="treeItem" slot-scope="title">
                <!-- 树结构输入框 -->
                <div v-if="title.type === 'input'" class="tree-input" :key="title.id"
                     @click="e => e.stopPropagation()">
                  <img class="tree-icon" src="@/assets/img/course/course-file.png" alt="">
                  <span>
                                        <input @blur.stop="treeInputBlur($event, title)" type="text"
                                               @keyup.enter="treeInputEnter"
                                               maxLength="15" ref="treeInput"
                                               class="ant-input ant-input-sm"
                                               placeholder="不能超过15个字符">
                                        <i @click="treeInputCancel(title)" class="cancel">取消</i>
                                    </span>
                </div>

                <!-- 树结构数据 -->
                <div v-else @dragstart="treeDrag($event, title)" :data-id="title.id"
                     :data-children="title.children && title.children.length"
                     :draggable="title.id !== 0 && tree.authEdit"
                     :class="title.id !== 0 && 'draggable'" class="tree-item">
                  <img v-if="title.index < 2" class="tree-icon"
                       src="@/assets/img/course/course-file.png"
                       alt="">
                  <img v-else class="tree-icon" src="@/assets/img/course/course-folder.png" alt="">
                  <span :title="title.name">{{ title.name }}</span>
                  <a v-show="tree.settingShow" class="ant-dropdown-link" @click.stop="treeAdd"
                     v-if="!title.id && tree.authEdit">新增</a>
                  <a-dropdown v-if="tree.authEdit && !!title.id" v-show="tree.settingShow">
                    <a class="ant-dropdown-link">
                      设置
                      <a-icon type="down"/>
                    </a>
                    <a-menu slot="overlay">
                      <a-menu-item v-if="title.index < 2">
                        <a @click.stop="treeSelectAdd(title)" href="javascript:;">新增</a>
                      </a-menu-item>
                      <a-menu-item>
                        <a @click.stop="treeSelectEdit(title)" href="javascript:;">编辑</a>
                      </a-menu-item>
                      <a-menu-item>
                        <a @click.stop="treeSelectDel(title)" href="javascript:;"
                           style="color: red;">删除</a>
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </div>
              </template>
            </a-tree>
          </div>
        </a-spin>
      </div>

      <div class="mid">
        <div style="min-width: 1000px;">
          <div @keyup.enter="getPageList(1)">
            <a-form-model layout="inline" :model="searchForm">
              <a-form-model-item label="课程系列">
                <a-input :maxLength="30" allowClear class="serach-item" v-model.trim="searchForm.name"
                         placeholder="请输入系列名称"/>
              </a-form-model-item>
              <a-form-model-item label="系列说明">
                <a-input :maxLength="30" allowClear class="serach-item" v-model.trim="searchForm.remark"
                         placeholder="请输入关键词"/>
              </a-form-model-item>
              <a-form-model-item label="课程名称">
                <a-input :maxLength="30" allowClear class="serach-item" v-model.trim="searchForm.courseName"
                         placeholder="请输入课程名称"/>
              </a-form-model-item>
              <a-form-model-item label="状态" v-if="tabActive !== 3">
                <a-select style="min-width: 180px" allowClear v-model="searchForm.enabled"
                          placeholder="请选择状态">
                  <a-select-option value="true">启用</a-select-option>
                  <a-select-option value="false">禁用</a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item label="审核状态" v-if="tabActive === 3">
                <a-select style="min-width: 180px" allowClear mode="multiple"
                          v-model="searchForm.status"
                          optionFilterProp="children"
                          placeholder="请选择审核状态">
                  <a-select-option value="0">录课中</a-select-option>
                  <a-select-option value="1">待审核</a-select-option>
                  <a-select-option value="2">审核通过</a-select-option>
                  <a-select-option value="3">审核失败</a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item style="margin-right: 35px;">
                <a-button @click="getPageList(1)" type="primary" html-type="button">
                  查询
                </a-button>
                <a-button @click="searchReset" style="margin-left: 10px;">
                  重置
                </a-button>
              </a-form-model-item>
              <a-form-model-item v-permission="authMap[tabActive].SeriesAdd">
                <a-button @click="addsSeries" icon="plus" type="primary">新建系列</a-button>
              </a-form-model-item>
            </a-form-model>
          </div>
          <a-table style="min-width: 800px;"
                   :columns="columns"
                   rowKey="id"
                   :key="tableRelevant.key"
                   @expand="getCourseList"
                   :pagination="tableRelevant.tablePagination"
                   :loading="tableRelevant.tableLoading"
                   :locale="tableRelevant.locale"
                   :dataSource="tableRelevant.tableDataSource">
            <a-switch slot="status" slot-scope="text, record" @change="tableStatusChange(text)" v-model="text.enabled"
                      checked-children="启用"
                      v-auth="`Content.Course.SeriesStatus`"
                      un-checked-children="禁用"/>
            <div slot="examineStatus" slot-scope="text" class="badge">
              <a-badge v-if="text === 0" status="default" text="录课中"/>
              <a-badge v-if="text === 1" status="processing" text="待审核"/>
              <a-badge v-if="text === 2" status="success" text="审核通过"/>
              <a-badge v-if="text === 3" status="error" text="审核失败"/>
            </div>
            <div class="action" slot="action" slot-scope="text, record"
                 @click="$store.commit('course/setSeriesInfo', text)">

              <div v-if="[1,2].includes(tabActive)">
                <a @click="editSeries(text, true)" v-permission="authMap[tabActive].SeriesPreview">查看</a>
                <a @click="offline(text)" class="red" v-permission="`Content.Course.SeriesOffline`">下线</a>
              </div>

              <div>
                <a @click="updateStatusSeries(text, 1)" v-permission="authMap[tabActive].SeriesSubmit"
                   v-if="[0, 3].includes(text.status)" class="red">提交</a>
                <a @click="beOnline(text)" v-if="text.status === 2"
                   v-permission="authMap[tabActive].SeriesBeOnline">上线</a>
                <span v-if="text.status !== 1">
                    <a @click="editSeries(text)" v-permission="authMap[tabActive].SeriesEdit">编辑</a>
                    <a @click="importCourseClick(text)" v-permission="authMap[tabActive].CourseImport">导入</a>
                    <a @click="addCourse(text)"
                       v-permission="[`/course/manage/CourseSeting`,authMap[tabActive].CourseAdd]">添加</a>
                </span>
                <span v-if="text.status === 1">
                  <a @click="updateStatusSeries(text, 2)" style="color: #52c41a;"
                     v-permission="authMap[tabActive].SeriesAdopt">通过</a>
                  <a @click="updateStatusSeries(text, 3)" class="red"
                     v-permission="authMap[tabActive].SeriesAdopt">拒绝</a>
                  <a v-if="[3].includes(tabActive)" @click="editSeries(text, true)"
                     v-permission="authMap[tabActive].SeriesPreview">查看</a>
                </span>
                <a @click="contentList(text, true)"
                   v-permission="[`/course/manage/ContentList`,authMap[tabActive].CourseContent]">内容</a>
                <a @click="courseSeriesDel(text.id)" v-if="[3].includes(tabActive)"
                   v-permission="authMap[tabActive].SeriesDel" class="red">删除</a>
              </div>
            </div>

            <CourseTable :authMap="authMap[tabActive]" :seriesInfo="text" :ref="`courseTable${text.id}`"
                         :courseName="searchForm.courseName" slot="expandedRowRender"
                         @updatePageList="getPageList" :key="text.id"
                         slot-scope="text"/>
          </a-table>
        </div>
      </div>
    </div>

    <a-modal title="导入课程"
             v-model="importCourse.visible"
             :confirm-loading="importCourse.confirmLoading"
             :destroyOnClose="true"
             :centered="true"
             @ok="importCourseOk"
             width="1100px">
      <ImportCourse ref="importCourse"/>
    </a-modal>

    <!--添加过编辑课程系列-->
    <a-modal :title="series.title"
             :visible="series.visible"
             :destroyOnClose="true"
             :centered="true"
             :footer="series.footer"
             @ok="seriesOk"
             :confirm-loading="series.confirmLoading"
             width="800px"
             @cancel="seriesCancel">
      <a-form-model ref="seriesForm" :model="series.form" :rules="series.rules"
                    :style="(series.disabled) && 'pointer-events: none;'"
                    :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item :wrapper-col="{ span: 14, offset: 5 }" prop="classificationId">
          <div class="series-tree-select">
            <div class="first">所属分类 <img src="@/assets/img/course/course-folder.png" alt=""></div>
            <a-tree-select v-model="series.form.classificationId"
                           ref="seriesTree"
                           style="width: 100%"
                           allowClear
                           @select="seriesTreeSelect"
                           :replaceFields="{key: 'id', value: 'id'}"
                           :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                           :tree-data="tree.treeData"
                           placeholder="请选择创建位置"
                           tree-default-expand-all>
              <div slot="treeItem" slot-scope="title"
                   :class="title.selectable === false && 'tree-selectable'">
                <img v-if="title.selectable === false" class="tree-icon"
                     src="@/assets/img/course/course-file.png" alt="">
                <img v-else class="tree-icon" src="@/assets/img/course/course-folder.png" alt="">
                <span :title="title.name">{{ title.name }}</span>
              </div>
            </a-tree-select>
            <div class="modify" @click="$refs.seriesTree.$el.click()">修改</div>
          </div>

        </a-form-model-item>
        <a-form-model-item label="系列名称" prop="name">
          <a-input v-model="series.form.name" :maxLength="25" placeholder="不超过25个字符">
            <span slot="suffix">{{ series.form.name.length }} / 25</span>
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="系列说明">
          <div style="position: relative;">
            <a-textarea v-model="series.form.remark"
                        class="input-textarea"
                        :auto-size="{ minRows: 3, maxRows: 5 }"
                        :maxLength="50"
                        placeholder="不超过50个字符">
            </a-textarea>
            <span class="textarea-size">{{ series.form.remark.length }} / 50</span>
          </div>
        </a-form-model-item>
        <!--<a-form-model-item label="状态" prop="enabled" v-if="tabActive !== 3">
            <a-radio-group v-model="series.form.enabled">
                <a-radio :value="true">启用</a-radio>
                <a-radio :value="false">禁用</a-radio>
            </a-radio-group>
        </a-form-model-item>-->
      </a-form-model>
    </a-modal>

    <!-- 上下线课程系列-->
    <a-modal :title="offlineCourse.title + '课程系列'"
             :visible="offlineCourse.visible"
             :destroyOnClose="true"
             :centered="true"
             @ok="offlineCourseOk"
             :confirm-loading="offlineCourse.confirmLoading"
             width="800px"
             @cancel="offlineCourseCancel">
      <div style="width: 450px;margin: 0 auto;margin-bottom: 150px;">
        <div class="offline-head">
          <h3>{{ offlineCourse.info.name }}</h3>
        </div>
        <div class="series-tree-select offline-select">
          <div class="first">{{ offlineCourse.title }}到 <img src="@/assets/img/course/course-folder.png"
                                                              alt=""></div>
          <a-tree-select style="width: 100%"
                         allowClear
                         ref="offlineTree"
                         treeDefaultExpandAll
                         :key="offlineCourse.key"
                         v-model="offlineCourse.classificationId"
                         @select="offlineCourseTreeSelect"
                         :replaceFields="{key: 'id', value: 'id'}"
                         :dropdown-style="{ maxHeight: '230px', overflow: 'auto' }"
                         :tree-data="offlineCourse.treeData"
                         placeholder="请选择创建位置">
            <div slot="treeItem" slot-scope="title"
                 :class="title.selectable === false && 'tree-selectable'">
              <img v-if="title.selectable === false" class="tree-icon"
                   src="@/assets/img/course/course-file.png" alt="">
              <img v-else class="tree-icon" src="@/assets/img/course/course-folder.png" alt="">
              <span :title="title.name">{{ title.name }}</span>
            </div>
          </a-tree-select>
          <div @click="$refs.offlineTree.$el.click()" class="modify">修改</div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {tableRelevant, ModuleAuth} from "@/pages/projectImpl/js/utils";
import CourseTable from "./components/CourseTable";
import ImportCourse from "./components/ImportCourse";

const columns = [
  {
    title: '系列名称',
    dataIndex: 'name',
  },
  {
    title: '系列说明',
    dataIndex: 'remark',
    ellipsis: true,
    width: 300,
  },
  {
    title: '状态',
    width: 100,
    scopedSlots: {customRender: 'status'},
  },
  {
    title: '操作',
    width: 300,
    scopedSlots: {customRender: 'action'},
  },
];
const experimentColumns = [
  {
    title: '系列名称',
    dataIndex: 'name',

  },
  {
    title: '系列说明',
    dataIndex: 'remark',
    width: 300,
    ellipsis: true,
  },
  {
    title: '创建人',
    width: 150,
    dataIndex: 'creatorName',

  },
  {
    title: '审核状态',
    width: 100,
    dataIndex: 'status',
    scopedSlots: {customRender: 'examineStatus'},
  },
  {
    title: '操作',
    width: 280,
    scopedSlots: {customRender: 'action'},
  },
];

const authMap = {
  1: {
    "B": true,
    'SeriesDel': 'Content.Course.B.SeriesDel',
    'SeriesSubmit': 'Content.Course.B.SeriesSubmit',
    'SeriesBeOnline': 'Content.Course.B.SeriesBeOnline',
    "SeriesEdit": "Content.Course.B.SeriesEdit",
    "CourseImport": "Content.Course.B.CourseImport",
    "SeriesAdopt": "Content.Course.B.SeriesAdopt",
    "CourseContent": "Content.Course.B.CourseContent",
    "CourseAdd": 'Content.Course.B.CourseAdd',
    "SeriesPreview": 'Content.Course.B.SeriesPreview',
    "SeriesAdd": "Content.Course.B.SeriesAdd",
    "CourseRemove": "Content.Course.B.CourseRemove",
    "CourseDelete": 'Content.Course.B.CourseDelete',
  },
  2: {
    "C": true,
    'SeriesDel': 'Content.Course.C.SeriesDel',
    'SeriesSubmit': 'Content.Course.C.SeriesSubmit',
    'SeriesBeOnline': 'Content.Course.C.SeriesBeOnline',
    "SeriesEdit": "Content.Course.C.SeriesEdit",
    "CourseImport": "Content.Course.C.CourseImport",
    "SeriesAdopt": "Content.Course.C.SeriesAdopt",
    "CourseContent": "Content.Course.C.CourseContent",
    "CourseAdd": 'Content.Course.C.CourseAdd',
    "SeriesPreview": 'Content.Course.C.SeriesPreview',
    "SeriesAdd": "Content.Course.C.SeriesAdd",
    "CourseRemove": "Content.Course.C.CourseRemove",
    "CourseDelete": 'Content.Course.C.CourseDelete',
  },
  3: {
    'SeriesDel': 'Content.Course.SeriesDel',
    'SeriesSubmit': 'Content.Course.SeriesSubmit',
    'SeriesBeOnline': 'Content.Course.SeriesBeOnline',
    "SeriesEdit": "Content.Course.SeriesEdit",
    "CourseImport": "Content.Course.CourseImport",
    "SeriesAdopt": "Content.Course.SeriesAdopt",
    "CourseContent": "/course/manage/ContentList",
    "CourseAdd": '/course/manage/CourseSeting',
    "SeriesPreview": 'Content.Course.SeriesPreview',
    "SeriesAdd": "Content.Course.SeriesAdd",
    "CourseRemove": "Content.Course.CourseRemove",
    "CourseDelete": 'Content.Course.CourseDelete',
  },
};

export default {
  name: "Course",
  components: {CourseTable, ImportCourse},
  data() {
    return {
      authMap: Object.freeze(authMap),
      tabs: [
        {type: 1, name: "B端", auth: ModuleAuth("CourseCenterCourseManage", "Content.Course.B")},
        {type: 2, name: "C端", auth: ModuleAuth("CourseCenterCourseManage", "Content.Course.C")},
        {type: 3, name: "实验", auth: ModuleAuth("CourseCenterCourseManage", "Content.Course.S")},
      ].filter(f => f.auth),
      tabsAuth: [],
      tabKey: Date.now(),
      tabActive: Number(this.$route.query.type) || 1,
      tree: {
        key: Date.now(),
        settingShow: true,
        // 编辑权限
        authEdit: ModuleAuth("CourseCenterCourseManage", "Content.Course.Classify"),
        selectValue: [],
        expandedKeys: [],
        treeLoading: false,
        cancelClick: false,
        draggableBox: null,
        treeDropData: {
          position: "before",
          dataId: "",
          itemInfo: {},
        },
        treeData: [],
        copyTreeData: [],
      },

      searchForm: {
        name: this.$route.query.name,
        remark: this.$route.query.remark,
        courseName: this.$route.query.courseName,
        enabled: this.$route.query.enabled,
        status: this.$route.query.status,
        classificationId: undefined,
      },
      columns: columns,
      tableRelevant: tableRelevant.call(this),
      // 导入课程
      importCourse: {
        visible: false,
        confirmLoading: false,
        seriesInfo: {},
      },

      // 新增或编辑系列
      series: {
        visible: false,
        disabled: false,
        footer: undefined,
        confirmLoading: false,
        selectInfo: {},
        info: {
          name: "",
          remark: "",
        },
        title: "新建系列",
        form: {
          id: undefined,
          classificationId: undefined,
          enabled: undefined,
          name: "",
          remark: "",
          "resourceType": 0,
        },
        rules: {
          classificationId: [{required: true, message: '请选择创建位置', trigger: 'change'}],
          name: [{required: true, message: '请输入系列名称', trigger: 'change'}],
          enabled: [{required: true, message: '请选择状态', trigger: 'change'}],
        },
      },
      // 上/下线课程系列
      offlineCourse: {
        title: "下线课程系列",
        visible: false,
        confirmLoading: false,
        key: Date.now(),
        info: {},
        treeData: [
          {
            name: "B端",
            id: 1,
            children: [],
            selectable: false,
            scopedSlots: {title: 'treeItem'},
            auth: ModuleAuth("CourseCenterCourseManage", "Content.Course.B"),
          },
          {
            name: "C端",
            id: 2,
            children: [],
            selectable: false,
            scopedSlots: {title: 'treeItem'},
            auth: ModuleAuth("CourseCenterCourseManage", "Content.Course.C"),
          },
        ].filter(f => f.auth),
        classificationId: undefined,
      },
    };
  },
  activated() {
    this.$nextTick(() => {
      let record = this.$store.getters["course/getSeriesInfo"]();
      if (record && this.$refs[`courseTable${record.id}`]) {
        this.$refs[`courseTable${record.id}`].getCourseList(record.id);
      }
    });
  },
  mounted() {
    this.dragControllerDiv();
    if (this.tabs[0] && this.tabs[0].type) {
      this.tabActive = +this.$route.query.type || this.tabs[0].type;
      this.tabsChange();
    }
  },
  methods: {
    courseSeriesDel(id) {
      this.$confirm({
        title: '确认删除该系列？',
        centered: true,
        okType: 'danger',
        onOk: () => {
          this.$http.CourseResource.seriesDelete(id).then(res => {
            this.getPageList(1);
            this.$message.success('删除成功');
          });
        },
      });

    },
    tabsChange() {
      if (this.tabActive === 3) {
        this.columns = experimentColumns;
      } else {
        this.columns = columns;
      }
      this.searchForm.classificationId = undefined;
      if (this.$route.query.type != this.tabActive) {
        this.$router.push({
          query: {
            ...this.$route.query,
            ...this.searchForm,
            type: this.tabActive,
          },
        });
      }

      const initData = (arr, index, pNames) => {
        return arr.map(m => {
          m.pNames = [...pNames, m.name];
          if (m.id === null) {
            m.id = 0;
          }
          if (m.parentId === null) {
            m.parentId = 0;
          }
          if (m.children && m.children.length) {
            this.expandedKeysManage(m.id, "push");
            m.children = initData(m.children, index + 1, m.pNames);
          } else {
            m.children = [];
          }
          m.index = index;
          m.scopedSlots = {title: 'treeItem'};
          return m;
        });
      };

      this.tree.treeLoading = true;
      this.tree.expandedKeys = [];
      this.tree.selectValue = [];
      this.series.selectInfo = {};
      this.series.form.classificationId = undefined;
      this.getPageList(1);
      this.$http.CourseResource.classificationsGet({resourceType: 0, type: this.tabActive}).then(res => {
        this.tree.treeData = initData([res.data], 0, []);
        this.tree.copyTreeData = JSON.stringify(this.tree.treeData);
        this.tree.selectValue = [0];
        this.tree.key = Date.now();
      }).finally(() => {
        this.tree.treeLoading = false;
      });
    },
    treeSelect(selectedKeys, {node}) {
      this.series.selectInfo = {};
      this.series.form.classificationId = undefined;
      if (node.dataRef.index === 2) {
        this.series.selectInfo = selectedKeys[0] ? node.dataRef : {};
        this.series.form.classificationId = selectedKeys[0];
      }
      this.searchForm.classificationId = selectedKeys[0];
      this.getPageList(1);
    },
    expandedKeysManage(id, type) {
      let index = this.tree.expandedKeys.indexOf(id);
      if (type === "push") {
        if (index === -1) {
          this.tree.expandedKeys.push(id);
        }
      } else {
        if (index > -1) {
          this.tree.expandedKeys.splice(index, 1);
        }
      }
    },
    treeAdd() {
      if (this.tree.treeData[0].children && this.tree.treeData[0].children.length) {
        this.tree.treeData[0].children = [
          {
            parentId: this.tree.treeData[0].id,
            id: "add",
            type: "input",
            scopedSlots: {title: 'treeItem'},
          },
          ...this.tree.treeData[0].children,
        ];
      } else {
        this.tree.treeData[0].children = [{
          parentId: this.tree.treeData[0].id,
          id: "add",
          type: "input",
          scopedSlots: {title: 'treeItem'},
        }];
      }
      this.expandedKeysManage(this.tree.treeData[0].id, "push");
      this.treeInputFocus();
    },

    // 树结构input框四个事件
    treeInputFocus(val) {
      this.$nextTick(() => {
        this.$refs.treeInput.value = val || "";
        this.$refs.treeInput.focus();
        this.$refs.treeInput.select();
      });
    },
    treeInputEnter() {
      this.$refs.treeInput.blur();
    },
    treeInputBlur(ev, val) {
      const e = ev || event;
      setTimeout(() => {
        if (this.tree.cancelClick) {
          this.tree.cancelClick = false;
          return;
        }
        val.dataRef.type = undefined;
        val.dataRef.name = e.target.value || "未命名";
        this.tree.treeData = this.recursionNode(this.tree.treeData, val.dataRef);
        if (!val.dataRef.edit) {
          this.$http.CourseResource.classificationsAdd({
            "resourceType": 0,
            type: this.tabActive,
            name: val.dataRef.name,
            parentId: val.dataRef.parentId || undefined,
          }).then(res => {
            this.tabsChange();
          }).catch(() => {
            this.treeInputCancel(val);
          });
        } else {
          this.$http.CourseResource.classificationsEdit(val.dataRef.id, {
            name: val.dataRef.name,
            id: val.dataRef.id,
            parentId: val.dataRef.parentId || undefined,
          }).then(res => {
            this.tabsChange();
          }).catch(() => {
            val.dataRef.name = val.name;
            this.treeInputCancel(val);
          });
        }
      }, 300);
    },
    treeInputCancel(val) {
      this.tree.cancelClick = true;
      if (val.dataRef.id === "add") {
        this.tree.treeData = this.recursionNode(this.tree.treeData, val.dataRef, "del");
      } else {
        val.dataRef.type = undefined;
        this.tree.treeData = this.recursionNode(this.tree.treeData, val.dataRef);
      }
      this.expandedKeysManage(val.dataRef.id, "del");
    },

    // 树结构设置三个事件
    treeSelectAdd(val) {
      if (Array.isArray(val.dataRef.children)) {
        val.dataRef.children.unshift({
          id: "add",
          type: "input",
          parentId: val.id,
          scopedSlots: {title: 'treeItem'},
        });
      } else {
        val.dataRef.children = [{
          id: "add",
          type: "input",
          parentId: val.id,
          scopedSlots: {title: 'treeItem'},
        }];
      }
      this.expandedKeysManage(val.id, "push");
      this.tree.treeData = this.recursionNode(this.tree.treeData, val.dataRef);
      this.tree.key = Date.now();
      this.treeInputFocus();
    },
    treeSelectEdit(val) {
      val.dataRef.type = "input";
      val.dataRef.edit = true;
      this.tree.treeData = this.recursionNode(this.tree.treeData, val.dataRef);
      this.treeInputFocus(val.dataRef.name);
    },
    treeSelectDel(val) {
      this.$confirm({
        title: '确认删除该分类？',
        centered: true,
        onOk: () => {
          this.$http.CourseResource.classificationsDelete(val.id).then(res => {
            this.$message.success(res.message);
            this.tree.treeData = this.recursionNode(this.tree.treeData, val.dataRef, "del");
            if (!(val.dataRef.children && val.dataRef.children.length)) {
              this.expandedKeysManage(val.dataRef.id, "del");
            }
          });
        },
      });
    },

    // 树结构拖动3个事件
    treeDrag(ev, val) {
      const e = ev || event;
      this.tree.settingShow = false;
      try {
        const node = e.target.parentNode.parentNode.parentNode;
        if (node.tagName.toLowerCase() === "li" && node.firstChild.classList.contains("ant-tree-switcher_open")) {
          node.firstChild.click();
        }
      } catch (e) {
        console.error(e);
      }
      this.tree.treeDropData.itemInfo = val.dataRef;
      this.tree.draggableBox = document.createElement("div");
      this.tree.draggableBox.className = "draggable-box";
      document.ondragover = this.treeDragover.bind(this);
      document.ondrop = this.treeDrop.bind(this);
    },
    treeParentNode(node) {
      if (!node || !node.tagName || node.tagName.toLowerCase() === "li") {
        return null;
      }
      if (node.className === "tree-item draggable") {
        return node;
      }
      return this.treeParentNode(node.parentNode);
    },
    treeDragover(ev) {
      const e = ev || event;
      e.preventDefault();
      this.tree.settingShow = true;
      const node = this.treeParentNode(e.target);
      if (!node) {
        return;
      }
      this.tree.treeDropData.dataId = Number(node.getAttribute("data-id"));
      if (this.tree.treeDropData.itemInfo.id == this.tree.treeDropData.dataId) {
        return;
      }
      if (node.getAttribute("data-children") > 0 && this.tree.treeDropData.itemInfo.index === 2) {
        this.expandedKeysManage(this.tree.treeDropData.dataId, "push");
      } else {
        this.expandedKeysManage(this.tree.treeDropData.dataId, "del");
      }
      if (e.offsetY <= node.offsetHeight / 2) {
        this.tree.treeDropData.position = "before";
        node.parentNode.insertBefore(this.tree.draggableBox, node);
      } else {
        this.tree.treeDropData.position = "after";
        node.parentNode.insertBefore(this.tree.draggableBox, node.nextSibling);
      }
    },
    treeDrop(ev) {
      const e = ev || event;
      e.preventDefault();
      document.ondrop = null;
      document.ondragover = null;
      this.$message.destroy();
      const json = {
        newParentId: undefined,
        previousDisplayOrder: undefined,
        nextDisplayOrder: undefined,
      };
      let dragOneLevel = false; // 拖动的是否为一级 并且要插入到二级下面
      const getParentData = (arr, id, data) => {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id == id) {
            if (data.index === 1 && arr[i].index != data.index) {
              dragOneLevel = true;
              return;
            }
            json.newParentId = arr[i].parentId || undefined;
            if (this.tree.treeDropData.position === "before") {
              if (data.index === 2 && arr[i].index === 1 && arr[i - 1] === undefined) {
                dragOneLevel = true;
                return;
              }
              if (data.index === 2 && arr[i - 1] && arr[i - 1].index === 1) {
                json.newParentId = arr[i - 1].id;
                json.previousDisplayOrder = undefined;
                json.nextDisplayOrder = arr[i - 1].children[0] ? arr[i - 1].children[0].displayOrder : undefined;
                this.expandedKeysManage(arr[i - 1].id, "push");
                arr[i - 1].children.unshift(data);
                return;
              }
              if (arr[i - 1]) {
                json.previousDisplayOrder = arr[i].displayOrder;
              }
              if (arr[i]) {
                json.nextDisplayOrder = arr[i].displayOrder;
              }
              arr.splice(i, 0, data);
            } else {
              if (data.index === 2 && arr[i] && arr[i].index === 1) {
                json.newParentId = arr[i].id;
                json.previousDisplayOrder = undefined;
                json.nextDisplayOrder = arr[i].children[0] ? arr[i].children[0].displayOrder : undefined;
                this.expandedKeysManage(arr[i].id, "push");
                arr[i].children.unshift(data);
                return;
              }
              if (arr[i]) {
                json.previousDisplayOrder = arr[i].displayOrder;
              }
              if (arr[i + 1]) {
                json.nextDisplayOrder = arr[i].displayOrder;
              }
              arr.splice(i + 1, 0, data);
            }
            return;
          }
          if (arr[i].children && arr[i].children.length) {
            getParentData(arr[i].children, id, data);
          }
        }
      };
      const data = this.tree.treeDropData.itemInfo;
      this.tree.draggableBox.remove();
      this.tree.draggableBox = null;
      if (data.id == this.tree.treeDropData.dataId) {
        return;
      }
      this.tree.treeData = this.recursionNode(this.tree.treeData, data, "del");
      getParentData(this.tree.treeData, this.tree.treeDropData.dataId, data);
      if (dragOneLevel) {
        this.$message.warning("菜单不允许更换层级");
        this.tree.treeData = JSON.parse(this.tree.copyTreeData);
        return;
      }
      json.id = data.id;
      this.tree.treeLoading = true;
      this.$http.CourseResource.classificationsSort(json).then(res => {
        this.tabsChange();
      }).finally(() => {
        this.tree.treeLoading = false;
      });

    },


    getPageList(page) {
      for (let searchFormKey in this.searchForm) {
        if (this.searchForm[searchFormKey] === "") {
          this.searchForm[searchFormKey] = undefined;
        }
      }
      const params = {
        ResourceType: 0,
        type: this.tabActive,
        pageIndex: page || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.searchForm,
        classificationId: this.searchForm.classificationId || undefined,
      };
      this.$router.push({
        query: {
          ...this.$route.query,
          ...this.searchForm,
        },
      });
      this.tableRelevant.tableLoading = true;
      this.$http.CourseResource.seriesGet(params).then(res => {
        this.tableRelevant.key = Date.now();
        this.tableRelevant.tableDataSource = res.data.items;
        this.tableRelevant.tablePagination.total = res.data.totalCount;
        this.tableRelevant.tablePagination.current = res.data.pageIndex;
        this.$nextTick(() => {
          let record = this.$store.getters["course/getSeriesInfo"]();
          if (record && this.$refs[`courseTable${record.id}`]) {
            this.$refs[`courseTable${record.id}`].getCourseList(record.id);
          }
        });
      }).finally(() => {
        this.tableRelevant.tableLoading = false;
      });
    },
    searchReset() {
      for (let key in this.searchForm) {
        this.searchForm[key] = undefined;
      }
      this.getPageList(1);
    },
    getCourseList(expanded, record) {
      if (expanded) {
        this.$store.commit("course/setSeriesInfo", record);
        this.$nextTick(() => {
          this.$refs[`courseTable${record.id}`].getCourseList(record.id);
        });
      }
    },

    // 内容列表
    contentList(val) {
      this.$store.commit("course/setSeriesInfo", val);
      this.$router.push({
        path: "/course/manage/contentList",
        query: {
          fullPath: window.encodeURIComponent(this.$route.fullPath),
        },
      });
    },

    tableStatusChange(val) {
      this.$message.destroy();
      this.tableRelevant.tableLoading = true;
      const Params = {
        "isEnabled": val.enabled,
        "id": val.id,
      };
      this.$http.CourseResource.seriesEnabled(val.id, Params).catch(e => {
        val.enabled = !val.enabled;
      }).finally(() => {
        this.tableRelevant.tableLoading = false;
      });
    },
    updateStatusSeries(val, index, bool) {
      const json = {
        id: val.id,
        classificationId: val.classificationId,
        status: index,
        isContinue: false,
      };
      let _this = this;
      this.tableRelevant.tableLoading = true;
      this.$http.CourseResource.seriesStatus(val.id, json).then(res => {
        if (bool) {
          return;
        }
        switch (index) {
          case 1:
            this.$message.success("提交审核成功");
            break;
          case 2:
            this.$message.success("已通过审核");
            break;
          case 3:
            this.$message.warning("已拒绝审核");
            break;
          default:
            this.$message.success(message);
        }
        this.searchForm.classificationId = this.tree.selectValue[0];
        this.getPageList();
      }).catch(e => {
        if (index === 1 && e.data) {
          this.$confirm({
            title: message,
            icon: () => <a-icon type="close-circle" style="color:#f00;"/>,
            okText: '继续提交',
            cancelText: '返回',
            centered: true,
            content: createElement => {
              const msgArray = [];
              if (e.data.commercialGame.length) {
                msgArray.push(createElement("p", {style: {marginBottom: "5px"}}, "缺少常模：" + e.data.commercialGame.join("，")));
              }
              if (e.data.scientificGame.length) {
                msgArray.push(createElement("p", {style: {marginBottom: "5px"}}, "科研游戏：" + e.data.scientificGame.join("，")));
              }
              return createElement("div", {}, msgArray);
            },
            onOk: () => {
              json.isContinue = true;
              _this.$http.CourseResource.seriesStatus(json.id, json).then(res => {
                _this.$message.success("提交审核成功");
                _this.searchForm.classificationId = _this.tree.selectValue[0];
                _this.getPageList();
              });
            },
          });
          return;
        }
        this.$message.error(e.message);
      }).finally(() => {
        this.tableRelevant.tableLoading = false;
      });
    },
    importCourseClick(val) {
      this.importCourse.seriesInfo = val;
      this.importCourse.visible = true;
    },
    // 导入课程确认
    importCourseOk() {
      const selectedRowKeys = this.$refs.importCourse.$data.selectedRowKeys;
      this.$message.destroy();
      if (!selectedRowKeys.length) {
        this.$message.warning("请选择课程");
        return;
      }
      const json = {
        courseIds: selectedRowKeys,
        courseSeriesId: this.importCourse.seriesInfo.id,
      };
      this.importCourse.confirmLoading = true;
      this.$http.CourseResource.courseImport(json).then(res => {
        this.$message.success(res.message);
        this.$store.dispatch("course/setCourseStatus", this.importCourse.seriesInfo);
        this.importCourse.visible = false;
        this.$refs[`courseTable${this.importCourse.seriesInfo.id}`].getCourseList(this.importCourse.seriesInfo.id);
        this.getPageList();
      }).finally(() => {
        this.importCourse.confirmLoading = false;
      })
    },

    // 添加/编辑系列相关事件
    screenSeriesData(arr, id) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id === id) {
          this.seriesTreeSelect(id, {dataRef: {...arr[i]}});
          return;
        }
        if (arr[i].children && arr[i].children.length) {
          this.screenSeriesData(arr[i].children, id);
        }
      }
    },
    addsSeries() {
      this.tree.treeData[0].selectable = false;
      this.tree.treeData[0].children = this.tree.treeData[0].children.map(m => {
        m.selectable = false;
        return m;
      });
      this.series.visible = true;
      if (!this.series.form.classificationId) {
        this.series.form.classificationId = undefined;
      } else {
        this.screenSeriesData(this.tree.treeData, this.series.form.classificationId);
      }
    },
    editSeries(val, disabled) {
      this.series.disabled = !!disabled;
      this.series.info = JSON.parse(JSON.stringify(val));
      this.series.footer = disabled ? null : undefined;
      this.series.title = disabled ? "查看系列" : "编辑系列";
      this.tree.treeData[0].selectable = false;
      this.tree.treeData[0].children = this.tree.treeData[0].children.map(m => {
        m.selectable = false;
        return m;
      });
      this.series.visible = true;
      for (let key in this.series.form) {
        this.series.form[key] = val[key];
      }
      this.screenSeriesData(this.tree.treeData, val.classificationId);
    },
    // 编辑系列确定
    seriesOk() {
      this.$refs.seriesForm.validate(valid => {
        if (valid) {
          this.series.confirmLoading = true;
          this.series.form.enabled = undefined;
          (this.series.form.id ? this.$http.CourseResource.seriesEdit(this.series.form.id, this.series.form) : this.$http.CourseResource.seriesAdd(this.series.form)).then(res => {
            this.$message.success(res.message);
            if (this.series.form.id) {
              this.updateStatusSeries(this.series.form, 0, true);
            }
            this.getPageList();
            this.seriesCancel(true);
          }).finally(() => {
            this.series.confirmLoading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 编辑系列取消
    seriesCancel(bool) {
      if (bool !== true) {
        for (let formKey in this.series.form) {
          if (this.series.form[formKey] !== this.series.info[formKey]) {
            this.$confirm({
              title: `确认关闭【${this.series.title}】`,
              centered: true,
              onOk: () => {
                this.seriesCancel(true);
              },
            });
            return;
          }
        }
      }
      this.series.visible = false;
      this.series.title = "新建系列";
      this.tree.treeData[0].selectable = true;
      this.tree.treeData[0].children = this.tree.treeData[0].children.map(m => {
        m.selectable = true;
        return m;
      });
      this.series.info = {
        name: "",
        remark: "",
      };
      this.series.form = {
        id: undefined,
        enabled: undefined,
        classificationId: this.series.selectInfo.index === 2 ? this.series.selectInfo.id : undefined,
        name: "",
        remark: "",
      };
    },
    seriesTreeSelect(id, treeNode) {
      this.$nextTick(() => {
        const select = document.querySelector(".series-tree-select .ant-select-selection-selected-value");
        select.innerHTML = treeNode.dataRef.pNames.join(" / ");
        select.title = treeNode.dataRef.pNames.join(" / ");
        this.$refs.seriesForm.clearValidate("classificationId");
      });
    },

    // 上线
    beOnline(val) {
      this.offlineCourse.title = "上线";
      this.offlineCourse.info = val;
      this.offlineLoadTreeData(1, this.offlineCourse.treeData[0]);
      this.offlineLoadTreeData(2, this.offlineCourse.treeData[1]);
      this.offlineCourse.visible = true;
    },
    // 下线
    offline(val) {
      this.offlineCourse.title = "下线";
      this.offlineCourse.info = val;
      this.offlineCourse.treeData = ModuleAuth("CourseCenterCourseManage", "Content.Course.S") ? [{
        name: "实验",
        id: 3,
        children: [],
        selectable: false,
        scopedSlots: {title: 'treeItem'},
      }] : [];
      this.offlineLoadTreeData(3, this.offlineCourse.treeData[0]);
      this.offlineCourse.visible = true;
    },
    offlineCourseTreeSelect(id, treeNode) {
      this.offlineCourse.classificationId = id;
      this.$nextTick(() => {
        const select = document.querySelector(".offline-select .ant-select-selection-selected-value");
        select.innerHTML = treeNode.dataRef.pNames.join(" / ");
        select.title = treeNode.dataRef.pNames.join(" / ");
      });
    },
    offlineLoadTreeData(type, obj) {
      if (!obj) {
        return;
      }

      function editData(arr, pNames, index) {
        return arr.map(m => {
          m.isLeaf = true;
          m.scopedSlots = {title: 'treeItem'};
          m.pNames = [...pNames, m.name];
          m.selectable = !(index < 2);
          if (m.children && m.children.length) {
            m.isLeaf = false;
            m.children = editData(m.children, m.pNames, index + 1);
          }
          return m;
        });
      }

      this.$http.CourseResource.classificationsGet({resourceType: 0, type}).then(({data}) => {
        obj.children = editData(data.children, [obj.name], 1);
        this.offlineCourse.key = Date.now();
      });
    },
    // 下线课程系列确认
    offlineCourseOk() {
      this.$message.destroy();
      if (!this.offlineCourse.classificationId) {
        this.$message.warning(`请选择${this.offlineCourse.title}位置`);
        return;
      }
      const json = {
        id: this.offlineCourse.info.id,
        classificationId: this.offlineCourse.classificationId,
        status: this.offlineCourse.title === "下线" ? 2 : 4,
      };
      this.offlineCourse.confirmLoading = true;
      this.$http.CourseResource.seriesStatus(json.id, json).then(res => {
        this.$message.success("操作成功");
        this.offlineCourse.classificationId = undefined;
        this.offlineCourseCancel();
        this.getPageList(1);
      }).catch(({data, message}) => {
        if (this.offlineCourse.title === "上线" && data && data.length) {
          this.$error({
            title: '上线失败',
            centered: true,
            content: createElement => {
              return createElement("div", {}, [
                createElement("p", {style: {marginBottom: "20px"}}, "下列游戏缺失常模，请补充后再上线"),
                createElement("b", {}, data.join("，")),
              ]);
            },
          });
          return;
        }
        this.$message.error(message);
      }).finally(() => {
        this.offlineCourse.confirmLoading = false;
      });
    },
    // 下线课程系列取消
    offlineCourseCancel() {
      if (this.offlineCourse.classificationId !== undefined) {
        this.$confirm({
          title: `确认关闭【${this.offlineCourse.title}】课程系列`,
          centered: true,
          onOk: () => {
            this.offlineCourse.classificationId = undefined;
            this.offlineCourseCancel();
          },
        });
        return;
      }
      this.offlineCourse.visible = false;
      this.offlineCourse.treeData = [
        {
          name: "B端",
          id: 1,
          children: [],
          selectable: false,
          scopedSlots: {title: 'treeItem'},
          auth: ModuleAuth("CourseCenterCourseManage", "Content.Course.B"),
        },
        {
          name: "C端",
          id: 2,
          children: [],
          selectable: false,
          scopedSlots: {title: 'treeItem'},
          auth: ModuleAuth("CourseCenterCourseManage", "Content.Course.C"),
        },
      ].filter(f => f.auth);
    },


    addCourse(val) {
      this.$store.commit("course/setCourseInfo", null);
      this.$store.commit("course/setSeriesInfo", val);
      this.$router.push({
        path: "/course/manage/CourseSeting",
        query: {
          type: "add",
          name: "基本设置",
          fullPath: window.encodeURIComponent(this.$route.fullPath),
        },
      });
    },

    /**
     * 递归设置节点
     * @param arr 源数组
     * @param val 节点数据
     * @param type
     */
    recursionNode(arr, val, type) {
      if (type !== "del") {
        return arr.map(m => {
          if (m.children && m.children.length) {
            m.children = this.recursionNode(m.children, val, type);
          }
          if (m.id === val.id) {
            m = val;
          }
          return m;
        });
      }
      return arr.filter(f => {
        if (f.children && f.children.length) {
          f.children = this.recursionNode(f.children, val, type);
        }
        return f.id !== val.id;
      });
    },
    dragControllerDiv() {
      var that = this;
      var resize = document.getElementsByClassName('resize');
      var left = document.getElementsByClassName('left');
      var mid = document.getElementsByClassName('mid');
      var box = document.getElementsByClassName('box');
      for (let i = 0; i < resize.length; i++) {
        // 鼠标按下事件
        resize[i].onmousedown = function (e) {
          //颜色改变提醒
          resize[i].style.background = '#ebedf0';
          var startX = e.clientX;
          resize[i].left = resize[i].offsetLeft;
          // 鼠标拖动事件
          document.onmousemove = function (e) {
            var endX = e.clientX;
            var moveLen = resize[i].left + (endX - startX); // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
            var maxT = box[i].clientWidth - resize[i].offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度

            if (moveLen < 32) moveLen = 32; // 左边区域的最小宽度为32px
            if (moveLen > maxT - 150) moveLen = maxT - 150; //右边区域最小宽度为150px

            resize[i].style.left = moveLen; // 设置左侧区域的宽度

            for (let j = 0; j < left.length; j++) {
              left[j].style.width = moveLen + 'px';
              mid[j].style.width = (box[i].clientWidth - moveLen - 10) + 'px';
            }
          };
          // 鼠标松开事件
          document.onmouseup = function (evt) {
            //颜色恢复
            resize[i].style.background = '#ebedf0';
            document.onmousemove = null;
            document.onmouseup = null;
            resize[i].releaseCapture && resize[i].releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
            that.tabKey = Date.now();
          };
          resize[i].setCapture && resize[i].setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
          return false;
        };
      }
    },
  },
};
</script>

<style scoped>
#Course {
  display: flex;
  background-color: #fff;
  padding: 24px;
  overflow: hidden;
}

.left {
  width: 300px;
  min-height: 400px;
  flex-shrink: 0;
  /* border-right: 1px solid #ebedf0; */
  border-bottom: 1px solid #ebedf0;
  user-select: none;
  overflow: auto;
}

.course-right {
  flex-grow: 1;
  padding-left: 24px;
  overflow: auto;
  box-sizing: border-box;
}

.left >>> .ant-tabs-tab-active {
  font-size: 16px;
}

.left >>> .ant-tree-node-content-wrapper {
  height: auto;
}

.left >>> .draggable-box {
  width: 100%;
  height: 24px;
  border: 1px dashed #11a0f8;
}

.left >>> .ant-dropdown{
  z-index: 500;
}

.course-tree-add {
  width: 27px;
  margin-right: 10px;
  margin-bottom: -5px;
  cursor: pointer;
}

.tree-item {
  display: flex;
  align-items: center;
}

.tree-item > span {
  flex-shrink: 2;
  flex-grow: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tree-item:hover .ant-dropdown-link {
  display: inline;
}

.tree-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
  margin-right: 5px;
  pointer-events: none;
}

.tree-input .ant-input-affix-wrapper {
  width: calc(100% - 21px);
}

.tree-input {
  display: flex;
  align-items: center;
}

.tree-input span {
  flex-grow: 1;
  position: relative;
}

.tree-input .cancel {
  color: red;
  font-size: 12px;
  cursor: pointer;
  position: absolute;
  top: 1px;
  right: 10px;
  font-style: normal;
}

.tree-input .ant-input {
  font-size: 12px;
  height: 27px;
  line-height: 27px;
}

.tree-selectable {
  cursor: no-drop;
  opacity: 0.6;
}

.ant-tree li ul.ant-dropdown-menu {
  padding: 0;
}

.ant-tree li ul.ant-dropdown-menu li {
  padding: 5px 12px;
}

.ant-dropdown-link {
  font-size: 12px;
  float: right;
  margin-right: 10px;
  display: none;
}

.serach-item {
  width: 180px;
  margin-bottom: 15px;
}

.input-textarea {
  resize: none;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.input-textarea::-webkit-scrollbar {
  display: none;
}

.textarea-size {
  position: absolute;
  right: 10px;
  bottom: -3px;
}

.series-tree-select {
  height: 32px;
  display: flex;
  align-items: center;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding-left: 11px;
  font-size: 14px;
}

.series-tree-select .first {
  flex-shrink: 0;
  color: #aeaeae;
}

.series-tree-select .first img {
  width: 18px;
  vertical-align: sub;
  margin-left: 20px;
}

.series-tree-select >>> .ant-select-selection, .series-tree-select >>> .ant-select-selection:focus,
.series-tree-select >>> .ant-select-selection:active {
  border-width: 0;
  height: 100%;
  border-color: transparent;
  box-shadow: none;
}

.series-tree-select .ant-select {
  flex: 1 1;
  max-width: 270px;
}

.series-tree-select .modify {
  flex-shrink: 0;
  width: 60px;
  line-height: 32px;
  text-align: center;
  border-left: 1px solid #d9d9d9;
  cursor: pointer;
}

.offline-head {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  margin-top: 20px;
}

.offline-head p {
  flex-grow: 1;
}

/* 拖拽相关样式 */
/*包围div样式*/
.box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
}

/*左侧div样式*/
.left {
  height: 100%;
  background: #FFFFFF;
  position: relative;
  min-width: 150px;
}

/*拖拽区div样式*/
.resize {
  cursor: col-resize;
  float: left;
  background-color: #ebedf0;
  width: 2px;
  color: white;
  position: absolute;
  right: 0;
  height: 100%;
  z-index: 222;
}

/*拖拽区鼠标悬停样式*/
.resize:hover {
  color: #ebedf0;
}

/*右侧div'样式*/
.mid {
  flex-grow: 1;
  height: 100%;
  background: #fff;
  padding-left: 24px;
  overflow: auto;
}

.action {
  display: flex;
}

.action span {
  margin-right: 0;
}
</style>
